import { Component } from '@angular/core';

@Component({
    templateUrl: './full-page-layout.component.html',
    standalone: false
})
export class FullPageLayoutComponent { }